import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';

import { LiteracyInsightModalInfo, LiteracyInsightModalState } from '../types';

const initialLiteracyInsightModalState: LiteracyInsightModalState = {
  isLiteracyInsightModalVisible: false,
  literacyInsightModalInfo: null,
};

export const literacyInsightModalSlice = createSlice({
  name: 'literacyInsightModal',
  initialState: initialLiteracyInsightModalState,
  reducers: {
    setIsLiteracyInsightModalVisible: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isLiteracyInsightModalVisible = action.payload;
    },
    setLiteracyInsightModalInfo: (
      state,
      action: PayloadAction<LiteracyInsightModalInfo>,
    ) => {
      state.literacyInsightModalInfo = action.payload;
    },
  },
});

export const { setIsLiteracyInsightModalVisible, setLiteracyInsightModalInfo } =
  literacyInsightModalSlice.actions;

export const useLiteracyInsightModalStateSelector = () =>
  useAppSelector((state) => state.literacyInsightModal);

export const literacyInsightModalReducer = literacyInsightModalSlice.reducer;
